module.exports = __webpack_public_path__ + "img/Icon_Bin_gray.1d3c2333.svg";